// extracted by mini-css-extract-plugin
export default {"termsContainer":"terms_termsContainer__Hr6ZJ"};